/**
 * @enum {string}
 * Enum for Equivalence Charges.
 */
export const EquivalenceCharges = {
  YES: 'YES', // type 1
  NO: 'NO', // type 2
  BY_CHOICE: 'BY_CHOICE', // type 3
};

/**
 * @param {number} recargo - código de recargo de BC (1, 2 o 3)
 * @returns {EquivalenceCharges|undefined}
 */
export const parseEquivalenceCharges = (recargo) => {
  if (recargo === 1) {
    return EquivalenceCharges.YES;
  }
  if (recargo === 2) {
    return EquivalenceCharges.NO;
  }
  if (recargo === 3) {
    return EquivalenceCharges.BY_CHOICE;
  }
  return undefined;
};

/**
 * @typedef {Object} User
 * @property {number} id - The unique ID of the user.
 * @property {EquivalenceCharges} equivalenceCharges - The equivalence charges for the user.
 */
